import { render, staticRenderFns } from "./ChosenCategoryCardInner.vue?vue&type=template&id=09b583cd&scoped=true&"
import script from "./ChosenCategoryCardInner.vue?vue&type=script&lang=js&"
export * from "./ChosenCategoryCardInner.vue?vue&type=script&lang=js&"
import style0 from "./ChosenCategoryCardInner.vue?vue&type=style&index=0&id=09b583cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b583cd",
  null
  
)

export default component.exports